import { styled } from '@material-ui/core/styles'

export const GridContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.white,
  boxShadow: theme.customShadows[7],
  borderRadius: '8px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column-reverse',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    height: '340px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '320px',
  },
}))

export const ContentGrid = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
})

export const ContentBox = styled('div')(({ theme }) => ({
  padding: '40px 16px',
  [theme.breakpoints.up('md')]: {
    padding: '32px 80px',
  },
}))

export const QuotesIconBox = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
}))

export const UserInfoBox = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  marginTop: theme.spacing(4),
  justifyContent: 'space-between',
}))

export const UserDetailsBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const UserNameBox = styled('div')(({ theme }) => ({
  color: theme.colors.grey[700],
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '16px',
  '& .MuiTypography-subtitle2': {
    fontWeight: '600',
  },
}))

export const ImageBox = styled('div')(({ imageSrc, imageBgPosition, theme }) => ({
  backgroundImage: `url(${imageSrc})`,
  backgroundSize: 'cover',
  backgroundPosition: imageBgPosition?.xs || '50% 50%',
  minHeight: '284px',
  height: '100%',
  [theme.breakpoints.up('sm')]: {
    backgroundPosition: imageBgPosition?.sm || '50% 50%',
    minHeight: '320px',
  },
  [theme.breakpoints.up('md')]: {
    minHeight: '284px',
    minWidth: '400px',
    backgroundPosition: '50% 50%',
  },
  [theme.breakpoints.up('lg')]: {
    minWidth: '430px',
  },
}))
